var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex contact-info-container" },
    [
      _c("div", { staticClass: "code-view flex item-center mr-10" }, [
        _c("img", {
          staticClass: "qr-code mr-5",
          attrs: {
            src: _vm.$i18n.locale === "en" ? _vm.qrCodeEn : _vm.qrCodeCn,
          },
          on: {
            click: function ($event) {
              _vm.visible = true
            },
          },
        }),
        _c("div", [
          _c("div", { staticClass: "font-bold" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("newsMgt.overview")) +
                "\n            "
            ),
          ]),
          _vm.$i18n.locale === "en"
            ? _c("p", { staticClass: "scan-tips" }, [
                _vm._v(_vm._s(_vm.$t("newsMgt.scanTips"))),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "pointer mr-10 flex introduction-video item-center" },
        [
          _c("img", {
            staticClass: "mr-10 icon-pic",
            attrs: { src: require("@/assets/img/icon-introduction.png") },
          }),
          _c("div", [
            _c("div", { staticClass: "font-bold" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("newsMgt.videoIntroduction")) +
                  "\n            "
              ),
            ]),
            _c(
              "a",
              {
                staticClass: "onboard-link mr-5",
                on: {
                  click: function ($event) {
                    return _vm.renderVideo("en")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("newsMgt.videoList.en")))]
            ),
            _vm._v(">\n            "),
            _c(
              "a",
              {
                staticClass: "onboard-link mr-5",
                on: {
                  click: function ($event) {
                    return _vm.renderVideo("cn")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("newsMgt.videoList.cn")))]
            ),
            _vm._v(">\n            "),
            _c(
              "a",
              {
                staticClass: "onboard-link",
                on: {
                  click: function ($event) {
                    return _vm.renderVideo("yueyu")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("newsMgt.videoList.yueyu")))]
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "pointer flex contact-us item-center" }, [
        _c("img", {
          staticClass: "icon-pic mr-5",
          attrs: { src: require("@/assets/img/icon-contact.png") },
        }),
        _c(
          "a",
          { attrs: { target: "_top", href: "mailto:cnfmkpmgclicbt@kpmg.com" } },
          [_vm._v(_vm._s(_vm.$t("newsMgt.contactTeam")))]
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            "custom-class": "qrCode-dialog",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "340px", height: "420px" },
            attrs: {
              src:
                _vm.$i18n.locale === "en"
                  ? _vm.qrCodeEn4Dialog
                  : _vm.qrCodeCn4Dialog,
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }